<template>
  <div class="search">
    <div class="search__box">
      <form method="get" action="">
        <input type="text" name="search" placeholder="Zoek op productnaam of artikelnummer" @input="onInputChange" v-model="searchQuery">
        <button class="button button--search">
          <span class="icon icon--size-3 fill--blue icon--search">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M508.5 468.9L387.1 347.5c-2.3-2.3-5.3-3.5-8.5-3.5h-13.2c31.5-36.5 50.6-84 50.6-136C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c52 0 99.5-19.1 136-50.6v13.2c0 3.2 1.3 6.2 3.5 8.5l121.4 121.4c4.7 4.7 12.3 4.7 17 0l22.6-22.6c4.7-4.7 4.7-12.3 0-17zM208 368c-88.4 0-160-71.6-160-160S119.6 48 208 48s160 71.6 160 160-71.6 160-160 160z"></path></svg>

          </span>
        </button>
      </form>

      <div class="search__suggestions" v-if="(items.suggestions.length > 0 || items.categories.length > 0) && visible">
        <ul>
          <li class="suggestions suggestions--products spacing" v-if="items.categories.length > 0">
            <h3 class="text text--size-3"><strong>Categorieën</strong></h3>
            <ul class="">
              <li v-for="(category, index) in items.categories" :key="`category-${index}`">
                <a :href="`?category=${category.sNavDesc}`">{{ category.sNavDesc }}</a>
              </li>
            </ul>
          </li>
          <li class="suggestions suggestions--search spacing border--bottom" v-if="items.suggestions.length > 0">
            <h3 class="text text--size-3"><strong>Zoeksuggesties</strong></h3>
            <ul>
              <li v-for="(suggestion, index) in items.suggestions" :key="`suggestion-${index}` ">
                <a :href="`?search=${suggestion}`">{{ suggestion }}</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>


    </div>
  </div>

</template>

<script>
import Vue from 'vue'

import axios from 'axios'
import delayAdapterEnhancer from 'axios-delay'
const CancelToken = axios.CancelToken
const api = axios.create({
  adapter: delayAdapterEnhancer(axios.defaults.adapter)
});

export default {
  name: 'YzeSearch',
  data: function() {
    return {
      searchQuery: '',
      items: {
        suggestions: [],
        categories: []
      },
      visible: false,
      cancel: function() {}
    }
  },
  mounted: function() {
    document.addEventListener('click', (e) => {
      // Check if mouse events is in current component
      let inComponent = e.path.find(el => {
        return el.classList && el.classList.contains('search__box')
      })
      this.visible = inComponent ? true : false
      if (inComponent) {
        document.body.classList.remove('show-account')
      }
    })

  },
  methods: {
    onInputChange () {
      let self = this
      if (this.searchQuery.trim().length <= 2) {
        this.visible = false
        return null
      }
      const url = `https://testrestservicesyze.msgnl.com/Searchword/Suggestion/${this.searchQuery.replace('/', ' ')}`
      return new Promise(resolve => {
        self.cancel && self.cancel()
        api.get(url, {
          cancelToken: new CancelToken(function executor(c) {
            self.cancel = c;
          }),
          delay: 300
        }).then(response => {
          this.items.suggestions = []
          this.items.categories = []

          response.data.stNavWords && response.data.stNavWords.arrNavGroup && response.data.stNavWords.arrNavGroup.forEach((item, index) => {
            item.type = 'suggestion'
            item.index = index
            this.items.categories.push(item)
          })
          response.data.stSearchwords && response.data.stSearchwords.forEach((item) => {
            this.items.suggestions.push(item)
          })

          this.visible = true

          resolve(response.data)
        }).catch(function (thrown) {
        })
      })
    },
    focus () {
      this.visible = true
    },
    onDefaultSearch (query) {
      if (query.trim().length === 0) {
        return null
      }
      window.location.href = `${Vue.prototype.$baseURL}/${this.catalogURL}?search=${query}`
    },
    onSearchItemSelected (item) {
      this.selectedSearchItem = item
      if (item.type === 'product') {
        if (item.url) {
          window.location.href = item.url
        } else {
          window.location.href = `${Vue.prototype.$baseURL}/${item.object.url}`
        }
      } else {
        window.location.href = `${Vue.prototype.$baseURL}/${this.catalogURL}?tn_q=${item.title}`
      }
    },
    formatPrice (price) {
      return typeof Intl !== "undefined" ? new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(price) : price
    }
  }
}
</script>
